export default {"src":"https://images-cdn-staging.curipod.com/d-6723846b/_next/static/media/bground.4c7c3901.svg","height":1908,"width":2989};